import { Injectable } from '@angular/core'
// import { Instance } from 'flatpickr/dist/types/instance'

@Injectable({providedIn:"root"})
export class DateService {
  intervals = {
    'year': { interval: 31536000, singleName: 'عام', multiName: 'اعوام' },
    'month': { interval: 2592000, singleName: 'شهر', multiName: 'اشهر' },
    'week': { interval: 604800, singleName: 'اسبوع', multiName: 'اسابيع' },
    'day': { interval: 86400, singleName: 'يوم', multiName: 'ايام' },
    'hour': { interval: 3600, singleName: 'ساعه', multiName: 'ساعات' },
    'minute': { interval: 60, singleName: 'دقيقة', multiName: 'دقائق' },
    'second': { interval: 1, singleName: 'ثانيه', multiName: 'ثواني' },
  };
  constructor() { }

  getCurrentDate(days: number = 0) {
    let currentDate = new Date()
    if (days) {
      currentDate = new Date(currentDate.setDate(currentDate.getDate() + days))
    }

    return currentDate
  }

  increaseDays(days: number = 0,date:Date=new Date()) {
    return new Date(date.setDate(date.getDate() + days))
  }  
  increaseMinutes( minutes: number = 0 ,date:Date=new Date()) {
    return new Date(date.setMinutes(date.getMinutes() + minutes))
  }  

  // calculateDaysDifference(dateFromInstance: Instance, dateToInstance: Instance) {
  //   if (dateFromInstance.selectedDates.length > 0 && dateToInstance.selectedDates.length > 0) {
  //     const dateFrom = dateFromInstance.selectedDates[0] as Date
  //     const dateTo = dateToInstance.selectedDates[0] as Date
  //     const diffTime = Math.abs(dateTo.getTime() - dateFrom.getTime())
  //     return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  //     return
  //   } else {
  //     return 0
  //   }
  // }


  dateDiff(dateFrom: any) {
    if (!dateFrom) {
      return {
        inThePast: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }
    // get total seconds between the times
    let delta = Math.floor(+new Date(dateFrom) - +new Date()) / 1000;
    const inThePast = delta < 0;


    // calculate (and subtract) whole days
    // var years = Math.floor(delta / this.intervals.year.interval);
    // delta -= years * this.intervals.year.interval;

    // // calculate (and subtract) whole days
    // var months = Math.floor(delta / this.intervals.month.interval);
    // delta -= months * this.intervals.month.interval;

    // calculate (and subtract) whole days
    const days = Math.floor(delta / 86400);
    delta -= days * 86400;

    // calculate (and subtract) whole hours
    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    // calculate (and subtract) whole minutes
    const minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    // what's left is seconds
    const seconds = delta % 60;  // in theory the modulus is not required
    return {
      inThePast,
      //years:Math.abs(years),
      //months:Math.abs(months),
      days: Math.abs(days),
      hours: Math.abs(hours),
      minutes: Math.abs(minutes),
      seconds: Math.round(Math.abs(seconds))
    }
  }

  sinceFullHour(value: any) {
    const diff = this.dateDiff(value);
    if(diff.hours==0)
    {
      return `${diff.minutes.toString().padStart(2, '0')}:${diff.seconds.toString().padStart(2, '0')}`

    }
    return `${diff.hours.toString().padStart(2, '0')}:${diff.minutes.toString().padStart(2, '0')}:${diff.seconds.toString().padStart(2, '0')}`
    
  }

  sinceDate(value: any) {
    const seconds = Math.floor((+new Date(value) - +new Date()) / 1000);
    if (seconds < 29 && seconds > 0) {
      return 'الآن'
    }


    let counter;
    for (const i in this.intervals) {
      const invt = (this.intervals as any)[i];
      counter = Math.floor(seconds / invt.interval);
      if (counter > 0) {

        if (counter === 1) {
          return `${invt.singleName}` // singular (1 day ago)
        } else {
          return `${counter} ${invt.multiName}` // plural (2 days ago)
        }

      } else if (counter < 0) {
        if (counter === 1) {
          return `منذ ${invt.singleName}` // singular (1 day ago)
        } else {
          return `منذ ${counter * -1} ${invt.multiName}` // plural (2 days ago)
        }
      }
    }
    return '';
  }

  sameDay(dateFrom: Date, dateTo: Date = new Date()) {
    return dateFrom.getFullYear() === dateTo.getFullYear() &&
      dateFrom.getMonth() === dateTo.getMonth() &&
      dateFrom.getDate() === dateTo.getDate();
  }
}
